import { HandHeart, Eye, ShieldCheck } from "@phosphor-icons/react";
import { Reveal } from "../Reveal";

const PILLARS = [
    {
        icon: HandHeart,
        title: "Human Expertise",
        text: "Technology supports patients and healthcare professionals; it does not replace clinical judgment.",
    },
    {
        icon: Eye,
        title: "Transparency",
        text: "Clear information about providers, treatment options, estimated costs and the patient journey.",
    },
    {
        icon: ShieldCheck,
        title: "Privacy",
        text: "Patient information should be handled with strong privacy, security and consent principles.",
    },
];

export default function Trust() {
    return (
        <section data-testid="trust-section" className="py-28 lg:py-36 bg-tint-green noise-overlay">
            <div className="max-w-7xl mx-auto px-6 lg:px-8">
                <Reveal>
                    <p className="text-xs font-bold uppercase tracking-[0.25em] text-brand-green">
                        <span className="text-slate-400">04&nbsp;&nbsp;·&nbsp;&nbsp;</span>Our Principles
                    </p>
                </Reveal>
                <Reveal delay={0.1}>
                    <h2 data-testid="trust-statement" className="mt-5 max-w-4xl font-heading text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight leading-[1.1] text-brand-blue">
                        Technology should make healthcare <span className="text-brand-green">more human</span> — not less.
                    </h2>
                </Reveal>
                <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-6">
                    {PILLARS.map((p, i) => (
                        <Reveal key={p.title} delay={0.1 * i}>
                            <div
                                data-testid={`trust-pillar-${i + 1}`}
                                className="h-full bg-white/80 backdrop-blur rounded-3xl border border-white p-10 shadow-[0_8px_30px_rgb(13,148,136,0.06)] hover:-translate-y-1 hover:shadow-[0_20px_40px_rgb(13,148,136,0.12)] transition-[transform,box-shadow] duration-300"
                            >
                                <p.icon size={36} weight="duotone" className="text-brand-green" />
                                <h3 className="mt-6 font-heading text-xl font-semibold text-brand-blue">{p.title}</h3>
                                <p className="mt-3 text-sm leading-relaxed text-slate-600">{p.text}</p>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
